import { IGuia } from '../interface/IGuia';
import { URL_BACK } from '../functions';


export const finalizarChatEndPoint = (guia:IGuia):Promise<void> => {
    //const doc = bd.collection(`Chat`).doc(guia.guia);
    console.log(window.location.href);
    console.log(guia);
    const url = `${URL_BACK}/chat/finalizarChat`;
    const data = {
        "codigo_remision": guia.guia,
        "nombre_remitente": guia.nombre_destinatario,
        "remitente": "Cliente"
    };
    console.log(JSON.stringify(data));

    return fetch(url, {
        method: 'POST', // or 'PUT'
        body: JSON.stringify(data),
        headers:{
          'Content-Type': 'application/json'
        }
      }).then(res => res.json())
      .catch(error => console.error('Error:', error))
      .then(response => console.log('Success:', response));
 
  }